import { Layer, type Context, type Scope } from "effect";
import { ImmutableModelIo } from "./service.ts";
import { ImmutableModelIoLive } from "./live.ts";
import { ImmutableModelIdentityIoLive, ImmutableModelIdentityIoTest } from "./identity-io.ts";
import { ImmutableModelsLive } from "./models-service.ts";

export const ImmutableModelsRootLive = (owner: Scope.Scope) => ImmutableModelsLive(owner).pipe(
  Layer.provide(Layer.merge(ImmutableModelIoLive, ImmutableModelIdentityIoLive))
);

export const ImmutableModelsTest = (owner: Scope.Scope, io: Context.Service.Shape<typeof ImmutableModelIo>, identity: string) => ImmutableModelsLive(owner).pipe(
  Layer.provide(Layer.merge(Layer.succeed(ImmutableModelIo, io), ImmutableModelIdentityIoTest(identity)))
);
